module.exports = __webpack_public_path__ + "img/notary-journal_B09JRD7JRX.523153e3.jpg";